import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Switch } from '@material-ui/core';
import Popup from 'components/popup/popup';
import CustomTextField from 'components/Input/CustomTextField';
import { SYSTEM_CREATE_EMAIL_DOMAIN, UPDATE_EMAIL_DOMAIN } from 'store/key';
import useDialog from 'components/ConfirmDialog/useDialog';
import { setGlobalLoading } from 'store/global/reducer';
import { EMAIL_DOMAIN_CREATED } from 'utility/frontendMessage';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
        flex: 1,
        overflow: 'auto',
    },
    title: {
        fontWeight: 'bold',
    },
    item: {
        marginTop: theme.spacing(2),
    },
}));

export default function AddEmailDomain(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const rowData = props.selectedRow;
    const [domain, setDomain] = useState(rowData ? rowData.email : '');
    const [enable, setEnable] = useState(rowData ? rowData.enable : false);

    const [formDataValid, setFormDataValid] = useState(false);
    const [forceShowError, setForceShowError] = useState(false);

    const confirm = () => {
        setForceShowError(true);
        if (formDataValid && domain) {
            setGlobalLoading(true);
            let data = {
                email: domain,
                enable: enable,
            };

            if (!rowData) {
                dispatch({
                    type: SYSTEM_CREATE_EMAIL_DOMAIN,
                    payload: {
                        row: data,
                        callback: () => {
                            showDialog({
                                description: EMAIL_DOMAIN_CREATED,
                                disableCancelButton: true,
                            });

                            rowData ? props.editRow(data) : props.createUser(data);
                            setGlobalLoading(false);
                            props.setOpenPopup(false);
                        },
                    },
                });
            } else {
                data.id = rowData.id;
                dispatch({
                    type: UPDATE_EMAIL_DOMAIN,
                    payload: {
                        row: data,
                        callback: () => {
                            showDialog({
                                description: EMAIL_DOMAIN_CREATED,
                                disableCancelButton: true,
                            });

                            rowData ? props.editRow(data) : props.createUser(data);
                            setGlobalLoading(false);
                            props.setOpenPopup(false);
                        },
                    },
                });
            }
        }
    };
    const cancel = () => {
        props.setOpenPopup(false);
    };
    const reset = () => {
        setDomain('');
    };
    return (
        <Popup
            height="30%"
            width="30%"
            title={(rowData ? 'Edit' : 'Add') + ' Email Domain'}
            footerActions={[
                { label: 'Cancel', clicked: cancel, color: 'default' },
                { label: 'Reset', clicked: reset },
                { label: 'Confirm', clicked: confirm },
            ]}
            open={props.openPopup}
            closePopup={cancel}
        >
            <Grid container wrap="nowrap" direction="column" className={classes.container}>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        Domain:
                    </Grid>
                    <Grid container item xs={10}>
                        <CustomTextField
                            label="Domain"
                            name="domain"
                            value={domain}
                            onChange={(e) => setDomain(e.target.value)}
                            validators={['isRequired', 'isDomain', 'disableChinese']}
                            isValidValue={(valid) => setFormDataValid(valid)}
                            forceErrorDisplay={forceShowError}
                            maxLength={255}
                        />
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={2} className={classes.title}>
                        Enable:
                    </Grid>
                    <Grid container item xs={10}>
                        <Switch color="primary" checked={enable} onChange={(e) => setEnable(e.target.checked)} />
                    </Grid>
                </Grid>
            </Grid>
        </Popup>
    );
}
